module.exports = __webpack_public_path__ + "img/blue2.746bce31.jpg";